<template>
  <div class="mobile-components">
    <div
      class="mobile-components-item"
      v-for="item in list"
      :key="item.id"
      :class="{'is-particulars': parseInt(item.fieldType,10) === 11,'is-disabled':  item.disabled || disabled}"
    >
      <div v-if="item.isShow" class="mobile-components-item-main">
        <div
          class="required"
          v-if="parseInt(item.requrein,10) !== 1 && parseInt(item.fieldType,10) !== 11 && parseInt(item.fieldType,10) !== 44"
        >
        </div>
        <div
          class="label"
          v-if="parseInt(item.fieldType,10) !== 11"
        >
          {{ item.name }}
        </div>
        <child-components
          v-model="item.value"
          :commondata="commondata"
          :full-data="item"
          :disabled="disabled"
          v-if="parseInt(item.fieldType,10) !== 11"
          @change="changeValue"
        >
        </child-components>
        <!-- 明细区 -->
        <div
          class="mobile-particulars"
          v-if="parseInt(item.fieldType,10) === 11 && item.isShow"
        >
          <div class="mobile-particulars-title">
            {{ item.name }}
          </div>
          <div class="mobile-particulars-list">
            <div
              class="mobile-particulars-item"
              v-for="(cItem,cIndex) in item.sub"
              :key="cIndex"
            >
              <div class="mobile-particulars-item-details particulars-title" v-if="item.sub.length > 1 && !disabled">
                <div class="particulars-title-label">
                  {{ cIndex > 8 ? (cIndex+1) : '0'+(cIndex + 1) }}
                </div>
                <div class="el-icon el-icon-delete" @click.prevent.stop="deleteParticulars(item,cIndex)"></div>
              </div>
              <div
                v-for="(sItem,sIndex) in cItem"
                :key="sIndex"
                class="mobile-particulars-item-details"
                :class="{'is-disabled': sItem.disabled || disabled}"
              >
                <div v-if="sItem.isShow" class="mobile-particulars-item-details-main">
                  <div class="label">
                    <div class="required" v-if="parseInt(sItem.requrein,10) !== 1 && parseInt(sItem.fieldType,10) !== 44"></div>
                    {{ sItem.name }}
                  </div>
                  <child-components
                    :commondata="commondata"
                    v-model="sItem.value"
                    :full-data="sItem"
                    @change="changeValue"
                    :disabled="disabled"
                  >
                  </child-components>
                </div>
              </div>
            </div>
          </div>
          <div
            class="add-mobile-particulars"
            @click="addParticulars(item)"
            v-if="!disabled"
          >
            <span class="el-icon-plus"></span>添加{{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import childComponents from "./childComponents";

export default {
  name: "mobileComponents",
  props: ["list", "disabled", "commondata"],
  components: {
    childComponents
  },
  methods: {
    changeValue(itemData) {
      this.$emit("change", itemData);
    },
    /**
     * @description 添加新的明细行
     * @param itemData
     */
    addParticulars(itemData) {
      let newParticulars = JSON.parse(JSON.stringify(itemData.sub[0]))
      newParticulars.map(item => {
        item.value = null;
      })
      itemData.sub.push(newParticulars)
    },
    /**
     * @description 删除指定明细行
     * @param itemData
     * @param index
     */
    deleteParticulars(itemData, index) {
      itemData.sub.splice(index, 1)
    }
  }
};
</script>

<style lang="scss">
  .mobile-components {
    width: 100%;

    .mobile-components-item {
      .mobile-components-item-main {
        background-color: #ffffff;
        padding: 0 30px 0 20px;
        line-height: 50px;
        position: relative;
        border-bottom: 1px solid #E8E8E8;
        display: flex;
        justify-content: flex-start;
        min-height: 50px;
        .flow {
          position: absolute;
          right: 20px;
        }
        .required {
          position: absolute;

          &::before {
            font-size: 14px;
            content: "*";
            color: #f56c6c;
            left: -10px;
            position: absolute;
          }
        }


        .label {
          width: 140px;
          font-size: 14px;
          line-height: 18px;
          margin: 16px 0;
          max-height: 36px;
          overflow: hidden;
        }

        // 明细区
        .mobile-particulars {
          width: 100%;

          .mobile-particulars-title {
            width: 100%;
            color: #4694df;
            border-bottom: 1px solid #E8E8E8;
            padding: 0 20px;
            background-color: #ffffff;
          }

          .mobile-particulars-list {
            display: block;
            width: 100%;

            .mobile-particulars-item {
              background-color: #ffffff;
              margin-top: 5px;

              &:nth-child(1) {
                margin-top: 0;
              }

              .mobile-particulars-item-details {
                &.particulars-title {
                  border-bottom: 1px solid #E8E8E8;
                  padding: 0 20px;
                  overflow: hidden;
                  display: flex;
                  position: relative;
                  justify-content: space-between;
                  line-height: 40px;

                  .particulars-title-label {
                    color: #4694df;
                  }

                  .el-icon {
                    line-height: 40px;
                  }
                }

                &.is-disabled {
                  color: #333333;
                  opacity: 1;
                  background-color: #f9f9f9;
                }

                .right-icon {
                  right: 5px;
                }

                .mobile-particulars-item-details-main {
                  border-bottom: 1px solid #E8E8E8;
                  padding: 0 20px;
                  overflow: hidden;
                  display: flex;
                  justify-content: flex-start;
                  position: relative;
                }
              }
            }
          }

          .add-mobile-particulars {
            text-align: center;
            background-color: #ffffff;
            margin-top: 5px;
          }
        }

        .mobile-components {
          width: calc(100% - 140px);
        }
      }

      &.is-particulars {
        .mobile-components-item-main {
          margin: 5px 0;
          padding: 0;
          background: none;
        }
      }

      &.hide {
        display: none;
      }

      &.is-disabled {
        .mobile-components-item-main {
          color: #333333;
          opacity: 1;
          background-color: #f9f9f9;
        }
      }

      &:nth-last-child(1) {
        .mobile-components-item-main {
          border: none;
        }
      }
    }

    .tips {
      font-size: 14px;
      color: #999999;
      padding: 10px 0 0;
    }
  }
</style>
